import React, { type ReactElement, useId } from 'react';
import { type IconType } from '../Icon/Icon';
import { type SidebarItem as SidebarItemType } from './navConfig';
import SidebarItem from './SidebarItem';
import SidebarList from './SidebarList';

type Props = {
  readonly label: string;
  readonly items: ReadonlyArray<SidebarItemType>;
  readonly icon?: IconType;
};

const SidebarSection = ({ label, icon, items }: Props): ReactElement => {
  const headingId = useId();

  return (
    <li>
      <SidebarItem id={headingId} label={label} icon={icon} />
      <SidebarList aria-labelledby={headingId}>
        {items.map((item) => (
          <SidebarItem
            key={item.href}
            href={item.href}
            exact={!item.href}
            icon={item.icon}
            label={item.text}
            nested={true}
          />
        ))}
      </SidebarList>
    </li>
  );
};

export default SidebarSection;
